import type { FilterGroup } from 'src/utils/common'
import { useMemo } from 'react'
import { ListPage } from 'src/components'
import { $consts } from 'src/plugins'
import { getSingleRule } from 'src/utils/common'

const ListTableSubTable = (props: {
  parentTableId: string,
  record: any,
  formCode: string,
  filterGroup?: FilterGroup
}) => {
  const formData = useMemo<any>(() => {
    return {
      fromWhere: {
        pageType: $consts['TABLE/FORM_TYPE_LIST_SUBPAGE'],
        locateType: $consts['TABLE/PAGE_LOCATE_LIST_ROW'],
        data: { record: props.record }
      },
      filterGroup: props.filterGroup,
      listTable: {
        parentTableId: props.parentTableId,
        runtimeFilterGroup: (listTable: any) => {
          return {
            Rules: [getSingleRule(listTable.tableConfig.PageTable.RELATION_FIELD, 1, props.record.ID)]
          }
        },
        tableProps: { size: 'small', bordered: true, className: 'list-table__subtable' },
        useScroll: { validScroll: false }
      }
    }
  }, [])

  return (
    <ListPage
      formCode={`${props.formCode}===${props.record.ID}`}
      formData={formData}
    />
  )
}

export default ListTableSubTable